import Vue from 'vue';
import axios from 'axios';
import Api from './api';
import * as auth from './../utils/auth';

export default (services, { token, refreshToken }) => {
  Vue.api = {};
  Vue.api.registry = [];
  Vue.api.isRefreshing = false;
  Vue.api.queue = [];

  Vue.api.updateCredentials = ({ token, refreshToken, email }) => {
    auth.saveToken(token, email);
    auth.saveRefreshToken(refreshToken, email);

    Vue.api.registry.forEach(name => {
      Vue.api[name].token = token;
      Vue.api[name].refreshToken = refreshToken;
    });
  };

  Vue.api.logout = () => {
    auth.deleteUser();
    auth.deleteActiveRole();

    Vue.api.registry.forEach(name => {
      Vue.api[name].logout();
    });
    window.location.href = '/login';
  };

  Vue.api.client = axios;

  services.forEach(service => {
    Vue.api.registry.push(service.name);
    let options = {
      baseUrl: service.baseUrl,
      token: token,
      refreshToken: refreshToken,
      authRequired: service.hasOwnProperty('authRequired')
        ? service.authRequired
        : false
    };
    if (service.lang) {
      options.lang = true;
    }
    Vue.api[service.name] = new Api(options);
  });
  Vue.prototype.$api = Vue.api;

  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return axios;
      },
      configurable: true
    },

    $http: {
      get() {
        return axios;
      },
      configurable: true
    }
  });
};
